import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Directive({
  selector: '[awIsInAnyRole]'
})
export class IsInAnyRoleDirective implements OnInit, OnDestroy {

  private hasView = true;
  private showIfInAnyRole: string[] = [];

  constructor(
    private authService: AuthService,
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
  ) {
  }

  @Input() set awIsInAnyRole(value: string[]) {
    this.showIfInAnyRole = value;
  }

  ngOnInit(): void {
    this.viewContainer.clear();
    this.hasView = false;
    const user = this.authService.loggedUser();
    if (this.hasView && this.showIfInAnyRole.find(role => user?.role == role)) {
      this.viewContainer.clear();
      this.hasView = false;
    } else if (!this.hasView && this.showIfInAnyRole.find(role => user?.role == role)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    }
  }

  ngOnDestroy(): void {
  }

}
